<div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
  <span class="tw-truncate tw-text-sm tw-font-medium tw-leading-normal tw-text-gray-900">{{ option().name }}</span>
  @if (option().statusLabel) {
  <span class="tw-shrink-0 tw-rounded-md tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-normal" [ngClass]="option().statusBadgeClass">
    {{ option().statusLabel }}
  </span>
  }
</div>
<span class="tw-text-xs tw-font-medium tw-leading-normal tw-text-gray-500">{{ option().dateRange }}</span>
